export default __webpack_public_path__ + "static/media/image-preview.cdbeead4.png";